import { Component } from 'react';

// Bir bileşen hata verirse tüm uygulama beyaz ekrana düşmesin; sadece o bölge hata gösterir.
// Ayrıca React.lazy ile yüklenen parçalar ağ hatasıyla yüklenemezse buraya düşer.
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary yakaladı:', error, info?.componentStack);
  }

  reset = () => this.setState({ error: null });

  render() {
    if (this.state.error) {
      return this.props.fallback ? this.props.fallback(this.state.error, this.reset) : null;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
